/**
 * @flow
 * @author: VaraKumar
 */

import React, { Component } from 'react'
import { FullWidthImageContainer, TestimonialImage } from './styledComponents'

class FullWidthImage extends Component {
  render() {
    const { imageUrl, altText, includeBottomMargin } = this.props

    return (
      <FullWidthImageContainer includeBottomMargin={includeBottomMargin}>
        <TestimonialImage
          draggable={false}
          className="lazyload"
          dataSrc={imageUrl}
          alt={altText}
        />
      </FullWidthImageContainer>
    )
  }
}

export default FullWidthImage



// WEBPACK FOOTER //
// ./src/components/Home/TestimonialSection/TestimonialComponents/ImageTestimonial/index.js